import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: eprivacy
 * Version: 7.3.0-ALPHA-3
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { getCookie, getCookies, setCookie, deleteCookie } from './utils/cookies';
var ConsentManager = /*#__PURE__*/function () {
  function ConsentManager(config) {
    _classCallCheck(this, ConsentManager);
    this.config = config; // the configuration
    this.consents = this.defaultConsents; // the consent states of the configured apps
    this.confirmed = false; // true if the user actively confirmed his/her consent
    this.changed = false; // true if the app config changed compared to the cookie
    this.states = {}; // keep track of the change (enabled, disabled) of individual apps
    this.executedOnce = {}; //keep track of which apps have been executed at least once
    this.watchers = new Set([]);
    this.loadConsents();
    this.applyConsents();
  }
  return _createClass(ConsentManager, [{
    key: "cookieName",
    get: function get() {
      return this.config.cookieName || 'orejime';
    }
  }, {
    key: "watch",
    value: function watch(watcher) {
      if (!this.watchers.has(watcher)) this.watchers.add(watcher);
    }
  }, {
    key: "unwatch",
    value: function unwatch(watcher) {
      if (this.watchers.has(watcher)) this.watchers.delete(watcher);
    }
  }, {
    key: "notify",
    value: function notify(name, data) {
      var _this = this;
      this.watchers.forEach(function (watcher) {
        watcher.update(_this, name, data);
      });
    }
  }, {
    key: "getApp",
    value: function getApp(name) {
      var matchingApps = this.config.apps.filter(function (app) {
        return app.name === name;
      });
      if (matchingApps.length > 0) return matchingApps[0];
      return undefined;
    }
  }, {
    key: "getDefaultConsent",
    value: function getDefaultConsent(app) {
      var consent = app.default;
      if (consent === undefined) consent = this.config.default;
      if (consent === undefined) consent = false;
      return consent;
    }
  }, {
    key: "defaultConsents",
    get: function get() {
      var consents = {};
      for (var i = 0; i < this.config.apps.length; i++) {
        var app = this.config.apps[i];
        consents[app.name] = this.getDefaultConsent(app);
      }
      return consents;
    }

    // If every app is either required or optOut, or both,
    // there is no need to ask for user consent.
  }, {
    key: "canBypassConsent",
    value: function canBypassConsent() {
      return this.config.apps.every(function (_ref) {
        var _ref$optOut = _ref.optOut,
          optOut = _ref$optOut === void 0 ? false : _ref$optOut,
          _ref$required = _ref.required,
          required = _ref$required === void 0 ? false : _ref$required;
        return optOut || required;
      });
    }
  }, {
    key: "declineAll",
    value: function declineAll() {
      var _this2 = this;
      this.config.apps.map(function (app) {
        _this2.updateConsent(app, false);
      });
    }
  }, {
    key: "acceptAll",
    value: function acceptAll() {
      var _this3 = this;
      this.config.apps.map(function (app) {
        _this3.updateConsent(app, true);
      });
    }
  }, {
    key: "updateConsent",
    value: function updateConsent(app, value) {
      if (app.required && !value) {
        return;
      }
      this.consents[app.name] = value;
      this.notify('consents', this.consents);
    }
  }, {
    key: "resetConsent",
    value: function resetConsent() {
      this.consents = this.defaultConsents;
      this.confirmed = false;
      this.applyConsents();
      deleteCookie(this.cookieName);
      this.notify('consents', this.consents);
    }
  }, {
    key: "getConsent",
    value: function getConsent(name) {
      return this.consents[name] || false;
    }
  }, {
    key: "_checkConsents",
    value: function _checkConsents() {
      var complete = true;
      var appNames = this.config.apps.map(function (app) {
        return app.name;
      });
      Object.keys(this.consents).forEach(function (key) {
        if (appNames.indexOf(key) === -1) {
          delete this.consents[key];
        }
      }.bind(this));
      this.config.apps.forEach(function (app) {
        if (typeof this.consents[app.name] === 'undefined') {
          this.consents[app.name] = this.getDefaultConsent(app);
          complete = false;
        }
      }.bind(this));
      this.confirmed = complete;
      if (!complete) this.changed = true;
    }
  }, {
    key: "loadConsents",
    value: function loadConsents() {
      var consentCookie = getCookie(this.cookieName);
      if (consentCookie !== null && consentCookie.value !== '') {
        this.consents = this.config.parseCookie(consentCookie.value);
        this._checkConsents();
        this.notify('consents', this.consents);
      }
      return this.consents;
    }
  }, {
    key: "saveAndApplyConsents",
    value: function saveAndApplyConsents() {
      this.saveConsents();
      this.applyConsents();
    }
  }, {
    key: "saveConsents",
    value: function saveConsents() {
      if (this.consents === null) deleteCookie(this.cookieName);
      var value = this.config.stringifyCookie(this.consents);
      setCookie(this.cookieName, value, this.config.cookieExpiresAfterDays || 120, this.config.cookieDomain);
      this.confirmed = true;
      this.changed = false;
    }
  }, {
    key: "applyConsents",
    value: function applyConsents() {
      for (var i = 0; i < this.config.apps.length; i++) {
        var app = this.config.apps[i];
        var state = this.states[app.name];
        var confirmed = this.confirmed || (app.optOut !== undefined ? app.optOut : this.config.optOut || false);
        var consent = this.getConsent(app.name) && confirmed;
        if (state === consent) continue;
        this.updateAppElements(app, consent);
        this.updateAppCookies(app, consent);
        if (app.callback !== undefined) app.callback(consent, app);
        this.states[app.name] = consent;
      }
    }
  }, {
    key: "applyConsentsOnce",
    value: function applyConsentsOnce(serviceName, consent, always) {
      for (var i = 0; i < this.config.apps.length; i++) {
        var app = this.config.apps[i];
        if (serviceName !== undefined && serviceName !== app.name) {
          continue;
        }
        var state = this.states[app.name];
        if (state === consent) {
          continue;
        }
        if (app.callback !== undefined) {
          app.callback(consent, app);
        }
        this.states[app.name] = consent;
        this.updateAppElements(app, consent);
        if (always) {
          this.updateAppCookies(app, consent);
          this.updateConsent(app, consent);
          this.saveConsents();
        }
      }
    }
  }, {
    key: "updateAppElements",
    value: function updateAppElements(app, consent) {
      // we make sure we execute this app only once if the option is set
      if (consent) {
        if (app.onlyOnce && this.executedOnce[app.name]) return;
        this.executedOnce[app.name] = true;
      }
      var elements = document.querySelectorAll("[data-name='" + app.name + "']");
      for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        var parent = element.parentElement;
        var dataset = element.dataset;
        var type = dataset.type;
        var attrs = ['href', 'src'];

        // we handle placeholder elements here...
        if (type === 'placeholder') {
          if (consent) {
            dataset['originaldisplay'] = element.style.display || 'flex';
            element.style.display = 'none';
          } else {
            element.style.display = dataset['originaldisplay'] || 'flex';
          }
        } else if (element.tagName === 'SCRIPT') {
          // we create a new script instead of updating the node in
          // place, as the script won't start correctly otherwise
          var newElement = document.createElement('script');
          for (var _i = 0, _Object$keys = Object.keys(dataset); _i < _Object$keys.length; _i++) {
            var key = _Object$keys[_i];
            newElement.dataset[key] = dataset[key];
          }
          newElement.type = 'opt-in';
          newElement.innerText = element.innerText;
          newElement.text = element.text;
          newElement.class = element.class;
          newElement.style.cssText = element.style;
          newElement.id = element.id;
          newElement.name = element.name;
          newElement.defer = element.defer;
          newElement.async = element.async;
          newElement.crossOrigin = element.crossOrigin;
          newElement.integrity = element.integrity;
          if (consent) {
            newElement.type = type;
            if (dataset.src !== undefined) newElement.src = dataset.src;
          }
          //we remove the original element and insert a new one
          parent.insertBefore(newElement, element);
          parent.removeChild(element);
        } else {
          // all other elements (images etc.) are modified in place...
          if (consent) {
            var _iterator = _createForOfIteratorHelper(attrs),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var attr = _step.value;
                var attrValue = dataset[attr];
                if (attrValue === undefined) continue;
                if (dataset['original' + attr] === undefined) dataset['original' + attr] = element[attr];
                element[attr] = attrValue;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            if (dataset.title !== undefined) element.title = dataset.title;
            if (dataset.originalDisplay !== undefined) {
              element.style.display = dataset.originalDisplay;
            } else {
              element.style.display = 'initial';
            }
          } else {
            if (dataset.title !== undefined) {
              element.removeAttribute('title');
            }
            if (dataset.hide === 'true') {
              if (dataset.originalDisplay === undefined) {
                dataset.originalDisplay = element.style.display;
              }
              element.style.display = 'none';
            }
            var _iterator2 = _createForOfIteratorHelper(attrs),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _attr = _step2.value;
                var _attrValue = dataset[_attr];
                if (_attrValue === undefined) {
                  continue;
                }
                if (dataset['original' + _attr] !== undefined) {
                  element[_attr] = dataset['original' + _attr];
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        }
      }
    }
  }, {
    key: "updateAppCookies",
    value: function updateAppCookies(app, consent) {
      if (consent) return;
      function escapeRegexStr(str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      }
      if (app.cookies !== undefined && app.cookies.length > 0) {
        var cookies = getCookies();
        for (var i = 0; i < app.cookies.length; i++) {
          var cookiePattern = app.cookies[i];
          var cookiePath = void 0,
            cookieDomain = void 0;
          if (cookiePattern instanceof Array) {
            var _cookiePattern = cookiePattern;
            var _cookiePattern2 = _slicedToArray(_cookiePattern, 3);
            cookiePattern = _cookiePattern2[0];
            cookiePath = _cookiePattern2[1];
            cookieDomain = _cookiePattern2[2];
          }
          if (!(cookiePattern instanceof RegExp)) {
            cookiePattern = new RegExp('^' + escapeRegexStr(cookiePattern) + '$');
          }
          for (var j = 0; j < cookies.length; j++) {
            var cookie = cookies[j];
            var match = cookiePattern.exec(cookie.name);
            if (match !== null) {
              deleteCookie(cookie.name, cookiePath, cookieDomain);
            }
          }
        }
      }
    }
  }]);
}();
export { ConsentManager as default };